<template>
  <div class="notes-container">
    <h3><a @click="toggleNotes()"><i class="fa fa-thumb-tack" aria-hidden="true"/>{{ noteHeading }}<i v-if="collapsible && showNotes" class="fa fa-chevron-up" /><i v-if="collapsible && !showNotes" class="fa fa-chevron-down" /></a></h3>
    <collapse v-model="showNotes">
      <template v-if="editable" class="strategy-notes">
        <EditableWikiTextArea
          class="gb-text-3"
          :value="editedNotes"
          :placeholder-text="placeholderText"
          :reset-value="notes"
          @textReset="notesEdited"
          @textEdited="notesEdited"
        />
      </template>
      <template v-else class="strategy-notes">
        <WikiText class="gb-text-3" :text="notes"/>
      </template>
    </collapse>
  </div>
</template>

<script>
import WikiText from '@/components/WikiText'
import EditableWikiTextArea from '@/components/EditableWikiTextArea'

export default {
  name: 'StrategyNotes',
  components: {
    WikiText,
    EditableWikiTextArea
  },
  data() {
    return {
      showNotes: true,
      editedNotes: this.notes || ''
    }
  },
  props: {
    userName: {
      type: String,
      required: true
    },
    notes: {
      type: String,
      default: ''
    },
    studentName: {
      type: String,
      required: true
    },
    collapsible: {
      type: Boolean,
      default: false
    },
    editable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    placeholderText() {
      return `How could you implement this strategy?`
    },
    noteHeading() {
      return this.editable ? `Notes for ${this.studentName}` : `${this.userName}'s Notes`
    }
  },
  methods: {
    toggleNotes() {
      if (this.collapsible) {
        this.showNotes = !this.showNotes
      }
    },
    notesEdited(editedNotes) {
      this.editedNotes = editedNotes
      this.$emit('notesEdited', editedNotes)
    }
  }
}
</script>

<style lang="less" scoped>
h3 {
  margin-top: 0;
  a {
    cursor: pointer;
    font-weight: 700;
  }
  .fa-chevron-up {
    float: right;
  }
  .fa-chevron-down {
    float: right;
  }
}
.notes-container {
  background-color: #fffddd;
  padding: 10px 15px;
  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.26);
}
.strategy-notes {
  font-size: 24px;
  font-weight: 300;
  line-height: 36px;
}
</style>
